import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {Internship} from './internship.model';
import {UserModelListService} from '../../common/user-model-list.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class InternshipService extends UserModelListService<Internship> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'internship', Internship);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/internship/internship.service.ts